import UserFeedbackAdminPage from './UserFeedbackAdminPage';

const userFeedbackAdminModule = {
  pages: [
    UserFeedbackAdminPage,
  ],
};

export default userFeedbackAdminModule;
